import config from '../../../config';
import Location from '../../../ports-frontend/Location';
import Window from '../../../ports-frontend/Window';
import { LogicContext } from '../types';
import { HOMEPAGE_BASE_PATH } from '../constants';
import { extractControllersData } from 'src/logic/controllers';
import { extractNavigationLinksFromNavComponent } from '../utils';

export async function fetchPageInfo(
  context: LogicContext,
  event: { data: { [key: string]: any } }
) {
  const preloadedLayout = await Window.getInitialPresenterLayout();
  if (preloadedLayout && preloadedLayout.renderManifest) {
    const {
      renderManifest,
      id,
      trackingInfo,
      seo = {},
      properties,
    } = preloadedLayout;
    let pageTrackingData = trackingInfo;
    const { liveDealerTables = [], personalizedBanners = [] } =
      renderManifest || {};

    const navigationLinks = extractNavigationLinksFromNavComponent(
      renderManifest.components.StaticNavigation,
      context.currentScreenSize
    );

    const isSidebarInLayout = !!Object.entries(renderManifest.components).find(
      ([key, values]: [string, any]) =>
        key === 'Modal' && values.children.length
    );

    if (isSidebarInLayout) {
      pageTrackingData = {
        ...pageTrackingData,
        page: {
          ...pageTrackingData,
          SiteSectionCategory:
            context.trackingData?.page?.SiteSectionCategory ||
            pageTrackingData['SiteSectionCategory'] ||
            'Featured',
        },
      };
    }

    const controllersData = extractControllersData(
      Object.entries(renderManifest.components),
      false,
      context.controllersData
    );
    const mainLayoutPath = `${config.base_path || ''}${id}`;

    if (!config.history.enabled) {
      return {
        isLayoutPreloaded: !!preloadedLayout,
        path: mainLayoutPath,
        currentPagePath: mainLayoutPath,
        trackingInfo: pageTrackingData,
        liveDealerTables,
        personalizedBanners,
        seo,
        pageTitle: properties.pageTitle,
        controllersData,
        mainLayoutPath,
        initialRequest: false,
        navigationLinks: navigationLinks || context.navigationLinks,
        isSidebarInLayout,
        isErrorPage:
          properties.status === 'NOT FOUND' ||
          properties.status === 'NOT_FOUND',
      };
    }
    const location = await Location.get();

    return {
      initialRequest: !event.data.location,
      path: location.pathname,
      currentPagePath: location.pathname,
      trackingInfo: pageTrackingData,
      isLayoutPreloaded: !!preloadedLayout,
      liveDealerTables,
      personalizedBanners,
      mainLayoutPath: HOMEPAGE_BASE_PATH,
      pageTitle: properties.pageTitle,
      seo,
      controllersData,
      navigationLinks: navigationLinks || context.navigationLinks,
      isSidebarInLayout,
      isErrorPage:
        properties.status === 'NOT FOUND' || properties.status === 'NOT_FOUND',
    };
  }
  if (!config.history.enabled) {
    return {
      initialRequest: true,
      isLayoutPreloaded: !!preloadedLayout,
      path: HOMEPAGE_BASE_PATH,
    };
  }
  const location = await Location.get();

  return {
    initialRequest: !event.data.location,
    path: location.pathname,
    isLayoutPreloaded: !!preloadedLayout,
  };
}
